export const MERGE_RESOURCES = ['pupil', 'student', 'teacher'] as const;
export type MergeResource = (typeof MERGE_RESOURCES)[number];
export const MERGE_VIEWS = ['export', 'merge', 'report', 'history'] as const;
export type MergeView = (typeof MERGE_VIEWS)[number];

export interface SchoolMergeContext {
    resource: string;
    school: string;
    onBusyChange?: (busy: boolean) => void;
}

export const getSchoolMergePath = (
    school: string,
    resource: string,
    view: MergeView = 'export'
) =>
    `/school/${encodeURIComponent(school)}/yhdistaminen?${new URLSearchParams({
        resource,
        view,
    })}`;
